import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateSpinWheelRegionEntity } from '../../domain/entities/UpdateSpinWheelRegionEntity'

export class UpdateSpinWheelRegionModel extends UpdateSpinWheelRegionEntity {

  constructor(dataDto: UpdateSpinWheelRegionEntity) {
    super()
    mapEntityProperties<UpdateSpinWheelRegionModel>(this, dataDto, {
      exclude: ['spinWheelRegions'],
      map: {
        spinWheelRegions: dataDto.spinWheelRegions?.map((region) => ({
          regionId: region.region?.id,
          districtIds: region.districtIds
        }))
      }
    })
  }
}
